<template>

  <div id="mainAPPDiv" data-container="wide" data-header-position="fixed" data-headerbg="color_1" data-layout="vertical"
    data-nav-headerbg="color_1" data-primary="color_1" data-sidebar-position="fixed" data-sidebar-style="full"
    data-sidebarbg="color_1" data-theme-version="light" direction="ltr">
    <div class="nav-header">
      <!--
          Retirado de novo pedido por pedido de Perri
          to="/admin/order-new"
      -->
      <!-- Alerta personalizado -->

      <div v-if="showAlert" class="card">
        <div class="custom-alert">
          <div class="custom-alert-content">
            <h2>Alerta</h2>
            <p>A criação de pedidos via Portal está indisponível no momento.</p>
            <button @click="handleAlertOk">OK</button>
          </div>

        </div>

      </div>


      <router-link v-if="notIsScreem" class="brand-logo" to="/">
        <img class="logo-full" src="../../assets/images/logo.png" />

        <img class="logo-mini" src="../../assets/images/favicon.png" />

      </router-link>
      <router-link v-else class="brand-logo" to="/">
        <img class="logo-full" src="../../assets/images/favicon.png" />

        <img class="logo-mini" src="../../assets/images/favicon.png" />
      </router-link>

      <div class="user-company-name hidden-md-and-up">
        {{ $store.getters.user ? $store.getters.user.customer_name : '' }}
      </div>

      <div class="hamburger hidden-md-" @click="toggleMobileMenu">
        <span class="line"></span><span class="line"></span><span class="line"></span>
      </div>

    </div>

    <header-bar @activateSpinner="activateSpinner" @toggleMobileMenu="toggleMobileMenu" @setChangingCompany="handleChangingCompany"
      :key="currentCompany" v-if="!changingCompany">
    </header-bar>

    <!-- Menu Desktop -->
    <div class="deznav desktop-menu" style="box-shadow: #D3D3CD 0px 3px 5px 2px;">
      <div class="deznav-scroll">
        <ul id="menu" class="metismenu">
          <li class="nav-label first"></li>
          <li :class="{ 'active-menu mm-active': $route.path == '/admin' }">
            <router-link class="ai-icon" to="/admin">
              <font-awesome-icon :icon="['fa', 'home']" class="menu-icon" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Página Inicial </span>
            </router-link>
          </li>
          <!-- <li
              v-if="$store.getters.user.access.indexOf(1) > -1"
              :class="{ 'active-menu mm-active': $route.path == '/admin/kanban' }"
          >
              <router-link to="/admin/kanban" class="ai-icon">
                  <i class="flaticon-144-layout"></i>
                  <span class="nav-text">Resumo Geral </span>
              </router-link>
          </li>
        <li
            :class="{
              'active-menu mm-active': $route.path == '/admin/financial-dash',
            }"
          >
            <router-link to="/admin/financial-dash" class="ai-icon">
              <i class="flaticon-144-layout"></i>
              <span class="nav-text">Dashboard Fin </span>
            </router-link>
          </li> -->
          <li v-if="$store.getters.user.access.indexOf(2) > -1" :class="{
            'active-menu mm-active': $route.path == '/admin/contract-list',
          }">
            <router-link class="ai-icon" to="/admin/contract-list">
              <font-awesome-icon :icon="['fa', 'file-contract']" class="menu-icon" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Contratos</span>
            </router-link>
          </li>
          <li v-if="$store.getters.user.access.indexOf(3) > -1" :class="{
            'active-menu mm-active':
              $route.path == '/admin/invoice-list' ||
              $route.path == '/admin/financial-dash',
          }">
            <a aria-expanded="false" class="clickable ai-icon" @click="openMenu">
              <font-awesome-icon :icon="['fa', 'coins']" size="2x" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Financeiro</span>
              <font-awesome-icon :icon="!menuFinanceiroOpened ? ['fa', 'plus'] : ['fa', 'minus']" class="menu-sub-icon"
                style="float: right; font-weight: 100; margin-right: auto" />
            </a>
            <ul id="menuFinanceiro" aria-expanded="false" class="left mm-collapse">
              <li v-if="$store.getters.user.access.indexOf(4) > -1" class="mm-active">
                <router-link class="mm-active" to="/admin/invoice-list">Consulta de Títulos
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(5) > -1">
                <router-link class="mm-active" to="/admin/financial-dash">Dashboard Financeiro
                </router-link>
              </li>
            </ul>
          </li>

          <!-- <li v-if="$store.getters.user.access.indexOf(6) > -1" :class="{
                  'active-menu mm-active':
                      $route.path == '/admin/licitation-list' ||
                      $route.path == '/admin/licitation-form',
              }">
              <a class="clickable ai-icon" aria-expanded="false" @click="openMenuCotacao">
                  <img src="../../assets/images/icons/cotacao.png" width="23"
                      style="margin-left: -3px; margin-right: 15px" />
                  <span class="nav-text">Cotações</span>
                  <font-awesome-icon class="menu-icon"
                      style="float: right;; font-weight: 100; margin-right: auto"
                      :icon="!menuPedidosOpened ? ['fa', 'plus'] : ['fa', 'minus']" />
              </a>
              <ul aria-expanded="false" class="left mm-collapse" id="menuCotacoes">
                  <li class="mm-active" v-if="$store.getters.user.access.indexOf(7) > -1">
                      <router-link to="/admin/licitation-form" class="mm-active">Solicitar Cotação
                      </router-link>
                  </li>
                  <li v-if="$store.getters.user.access.indexOf(8) > -1">
                      <router-link to="/admin/licitation-list" class="mm-active">Cotações Solicitadas
                      </router-link>
                  </li>
              </ul>
          </li> -->
          <li v-if="$store.getters.user.access.indexOf(9) > -1" :class="{
            'active-menu mm-active':

              $route.path == '/admin/order-unbilled-list' ||
              $route.path == '/admin/order-list' ||
              $route.path == '/admin/order-new' ||
              $route.path == '/admin/order-finished-list' ||
              $route.path == '/admin/order-draft' ||
              $route.path == '/admin/order-list-ni',

          }">
            <a aria-expanded="false" class="clickable ai-icon" @click="openMenuOrder">

              <font-awesome-icon :icon="['fa', 'shopping-cart']" class="menu-icon" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Pedidos </span>
              <font-awesome-icon :icon="!menuPedidosOpened ? ['fa', 'plus'] : ['fa', 'minus']" class="menu-sub-icon"
                style="float: right; font-weight: 100; margin-right: auto" />
            </a>
            <ul id="menuPedidos" aria-expanded="false" class="left mm-collapse">
              <li v-if="$store.getters.user.access.indexOf(10) > -1">
                <router-link class="mm-active" to="/admin/order-new">Novo Pedido
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(11) > -1">
                <router-link class="mm-active" to="/admin/order-unbilled-list">Pedidos a Faturar
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(12) > -1" class="mm-active">
                <router-link class="mm-active" to="/admin/order-list">Pedidos em Rota
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(13) > -1" class="mm-active">
                <router-link class="mm-active" to="/admin/order-finished-list">Pedidos Entregues
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(14) > -1">
                <router-link class="mm-active" to="/admin/order-list-ni">Pedidos Realizados
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(15) > -1">
                <router-link class="mm-active" to="/admin/order-draft">Pedidos em Rascunho
                </router-link>
              </li>
            </ul>
          </li>

          <!-- <li v-if="$store.getters.user.access.indexOf(16) > -1" :class="{
      'active-menu mm-active': $route.path == '/admin/delivery-list',
  }">
              <a class="clickable ai-icon" aria-expanded="false" @click="openMenuDelivery">
                  <img src="../../assets/images/icons/entregas.png" width="23"
                      style="margin-left: -3px; margin-right: 14px" />
                  <span class="nav-text">Entregas </span>
                  <font-awesome-icon class="menu-icon"
                      style="float: right; font-weight: 100; margin-right: auto"
                      :icon="!menuPedidosOpened ? ['fa', 'plus'] : ['fa', 'minus']" />
              </a>
              <ul aria-expanded="false" class="left mm-collapse" id="menuDelivery">
                  <li v-if="$store.getters.user.access.indexOf(17) > -1">
                      <router-link to="/admin/delivery-list" class="mm-active">Entregas em Andamento
                      </router-link>
                  </li>
                  <li v-if="$store.getters.user.access.indexOf(18) > -1">
                      <router-link to="/admin/delivered-list" class="mm-active">Entregas Concluídas
                      </router-link>
                  </li>
              </ul>
          </li> -->
          <li v-if="dotEnv.isAmbientaly && $store.getters.user.access.indexOf(19) > -1" :class="{
            'active-menu mm-active': $route.path == '/admin/packaging-list',
          }">
            <router-link class="ai-icon" to="/admin/packaging-list">

              <font-awesome-icon :icon="['fa', 'box-open']" class="menu-icon" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Embalagens </span>
            </router-link>
          </li>

          <li v-if="$store.getters.user.access.indexOf(20) > -1" :class="{
            'active-menu mm-active':

              $route.path == '/admin/fds-list' ||
              $route.path == '/admin/fde-list' ||
              $route.path == '/admin/winner-docs',
          }">
            <a aria-expanded="false" class="clickable ai-icon" @click="openMenuDocuments">

              <font-awesome-icon :icon="['fa', 'file-alt']" class="menu-icon" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Documentos </span>
              <font-awesome-icon :icon="!menuDocumentsOpened ? ['fa', 'plus'] : ['fa', 'minus']" class="menu-sub-icon"
                style="float: right;; font-weight: 100; margin-right: auto" />
            </a>
            <ul id="menuDocuments" aria-expanded="false" class="left mm-collapse">
              <li v-if="$store.getters.user.access.indexOf(21) > -1" class="mm-active">
                <router-link class="mm-active" to="/admin/fds-list">FDS
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(22) > -1" class="mm-active">
                <router-link class="mm-active" to="/admin/fde-list">Ficha de Emergência
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(29) > -1" class="mm-active">
                <router-link class="mm-active" to="/admin/winner-docs">Certidões
                </router-link>
              </li>
            </ul>
          </li>

          <li v-if="$store.getters.user.access.indexOf(40) > -1" :class="{
            'active-menu mm-active': $route.path == '/admin/telemetry',
          }" class="menu-item-novo">
            <router-link class="ai-icon" to="/admin/telemetry">

              <font-awesome-icon :icon="['fa', 'broadcast-tower']" class="menu-icon" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Telemetria</span>
            </router-link>
          </li>

          <li v-if="$store.getters.user.access.indexOf(23) > -1" :class="{
            'active-menu mm-active':
              $route.path == '/admin/user-list' ||
              $route.path == '/admin/timelogs' ||
              $route.path == '/admin/customer-list' ||
              $route.path == '/admin/logaccess' ||
              $route.path == '/admin/configs' ||
              $route.path == '/admin/reports' ||
              $route.path == '/admin/report-export-logs',
          }">
            <a aria-expanded="false" class="clickable ai-icon" @click="openMenuAdministrativo">

              <font-awesome-icon :icon="['fa', 'cogs']" class="menu-icon" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Administrativo</span>
              <font-awesome-icon :icon="!menuAdministrativoOpened ? ['fa', 'plus'] : ['fa', 'minus']"
                class="menu-sub-icon" style="float: right;; font-weight: 100; margin-right: auto" />
            </a>
            <ul id="menuAdministrativo" aria-expanded="false" class="left mm-collapse">
              <li v-if="$store.getters.user.access.indexOf(24) > -1" :class="{
                'active-menu mm-active': $route.path == '/admin/user-list',
              }">
                <router-link class="mm-active" to="/admin/user-list">
                  Usuários
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(25) > -1" :class="{
                'active-menu mm-active': $route.path == '/admin/timelogs',
              }">
                <router-link class="mm-active" to="/admin/timelogs">
                  Tempo de Logs
                </router-link>
              </li>
              <!--                            <li-->
              <!--                                v-if="-->
              <!--                                  $store.getters.user.type_id == 4 ||-->
              <!--                                  $store.getters.user.type_id == 1-->
              <!--                                "-->
              <!--                                :class="{-->
              <!--                                  'active-menu mm-active':-->
              <!--                                    $route.path == '/admin/customer-list',-->
              <!--                                }"-->
              <!--                            >-->
              <!--                                <router-link to="/admin/customer-list" class="mm-active">-->
              <!--                                    Clientes-->
              <!--                                </router-link>-->
              <!--                            </li>-->

              <li v-if="$store.getters.user.access.indexOf(26) > -1" :class="{
                'active-menu mm-active': $route.path == '/admin/logaccess',
              }">
                <router-link class="mm-active" to="/admin/logaccess">
                  Log de Acesso
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(27) > -1" :class="{
                'active-menu mm-active': $route.path == '/admin/configs',
              }">
                <router-link class="mm-active" to="/admin/configs">
                  Configurações
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(28) > -1" :class="{
                'active-menu mm-active': $route.path == '/admin/reports',
              }">
                <router-link class="mm-active" to="/admin/reports">
                  Relatórios
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(28) > -1" :class="{
                'active-menu mm-active': $route.path == '/admin/report-export-logs',
              }">
                <router-link class="mm-active" to="/admin/report-export-logs">
                  Logs de Relatórios
                </router-link>
              </li>
            </ul>
          </li>
          <li v-else :class="{
            'active-menu mm-active': $route.path == '/admin/profile',
          }">
            <router-link class="ai-icon" to="/admin/profile">

              <font-awesome-icon :icon="['fa', 'user']" class="menu-icon" style="color: grey;" />
              <span class="nav-text" style="margin-left:10px">Meu Perfil </span>
            </router-link>
          </li>
          <!-- <li
            v-if="$store.getters.user.access_requests == 1"
            :class="{
              'active-menu mm-active': $route.path == '/admin/documents-list',
            }"
          >
            <a
              class="clickable ai-icon"
              aria-expanded="false"
              @click="openMenuDocuments"
            >
              <i class="flaticon-044-file"></i>
              <span class="nav-text">Documentos </span>
              <font-awesome-icon
                class="menu-icon"
                style="margin-left: 42%; font-weight: 100; margin-right: auto"
                :icon="['fa', 'plus']"
              />
            </a>
            <ul aria-expanded="false" class="left mm-collapse" id="menuDocuments">
              <li class="mm-active">
                <router-link to="/admin/documents-list" class="mm-active"
                  >FISPQ</router-link
                >
              </li>
            </ul>
          </li> -->
        </ul>
        <div class="copyright">
          <p>
            <strong>Grupo BAUMINAS</strong><br />
            © 2023 Todos os direitos reservados
          </p>
          <p>
            Desenvolvido por <a href="https://innovareti.com.br" target="_blank">InnovareTI</a>

          </p>
        </div>
      </div>
    </div>

    <!-- Menu Mobile -->
    <div class="mobile-menu-overlay" :class="{ 'active': isMobileMenuOpen }" @click="toggleMobileMenu"></div>
    <div class="mobile-menu" :class="{ 'active': isMobileMenuOpen }">
      <div class="mobile-menu-header">
        <router-link to="/" class="mobile-logo">
          <img src="../../assets/images/favicon.png" alt="Logo" />
        </router-link>
        <button class="close-menu" @click="toggleMobileMenu">
          <font-awesome-icon :icon="['fa', 'times']" />
        </button>
      </div>
      <div class="mobile-menu-content">
        <ul class="mobile-menu-list">
          <li :class="{ 'active': $route.path == '/admin' }">
            <router-link to="/admin">
              <font-awesome-icon :icon="['fa', 'home']" />
              <span>Página Inicial</span>
            </router-link>
          </li>
          <li v-if="$store.getters.user.access.indexOf(2) > -1"
            :class="{ 'active': $route.path == '/admin/contract-list' }">
            <router-link to="/admin/contract-list">
              <font-awesome-icon :icon="['fa', 'file-contract']" />
              <span>Contratos</span>
            </router-link>
          </li>
          <li v-if="$store.getters.user.access.indexOf(3) > -1">
            <a @click="toggleSubmenu('financeiro')" class="submenu-trigger">
              <font-awesome-icon :icon="['fa', 'coins']" />
              <span>Financeiro</span>
              <font-awesome-icon :icon="['fa', submenuFinanceiro ? 'minus' : 'plus']" class="submenu-icon" />
            </a>
            <ul v-if="submenuFinanceiro" class="submenu">
              <li v-if="$store.getters.user.access.indexOf(4) > -1">
                <router-link to="/admin/invoice-list">
                  <font-awesome-icon :icon="['fa', 'file-invoice']" />
                  <span>Consulta de Títulos</span>
                </router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(5) > -1">
                <router-link to="/admin/financial-dash">
                  <font-awesome-icon :icon="['fa', 'chart-line']" />
                  <span>Dashboard Financeiro</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li v-if="$store.getters.user.access.indexOf(9) > -1">
            <a @click="toggleSubmenu('pedidos')" class="submenu-trigger">
              <font-awesome-icon :icon="['fa', 'shopping-cart']" />
              <span>Pedidos</span>
              <font-awesome-icon :icon="['fa', submenuPedidos ? 'minus' : 'plus']" class="submenu-icon" />
            </a>
            <ul v-if="submenuPedidos" class="submenu">
              <li v-if="$store.getters.user.access.indexOf(10) > -1">
                <router-link to="/admin/order-new">Novo Pedido</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(11) > -1">
                <router-link to="/admin/order-unbilled-list">Pedidos a Faturar</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(12) > -1">
                <router-link to="/admin/order-list">Pedidos em Rota</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(13) > -1">
                <router-link to="/admin/order-finished-list">Pedidos Entregues</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(14) > -1">
                <router-link to="/admin/order-list-ni">Pedidos Realizados</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(15) > -1">
                <router-link to="/admin/order-draft">Pedidos em Rascunho</router-link>
              </li>
            </ul>
          </li>
          <li v-if="$store.getters.user.access.indexOf(20) > -1">
            <a @click="toggleSubmenu('documentos')" class="submenu-trigger">
              <font-awesome-icon :icon="['fa', 'file-alt']" />
              <span>Documentos</span>
              <font-awesome-icon :icon="['fa', submenuDocumentos ? 'minus' : 'plus']" class="submenu-icon" />
            </a>
            <ul v-if="submenuDocumentos" class="submenu">
              <li v-if="$store.getters.user.access.indexOf(21) > -1">
                <router-link to="/admin/fds-list">FDS</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(22) > -1">
                <router-link to="/admin/fde-list">Ficha de Emergência</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(29) > -1">
                <router-link to="/admin/winner-docs">Certidões</router-link>
              </li>
            </ul>
          </li>
          <li v-if="$store.getters.user.access.indexOf(23) > -1">
            <a @click="toggleSubmenu('administrativo')" class="submenu-trigger">
              <font-awesome-icon :icon="['fa', 'cogs']" />
              <span>Administrativo</span>
              <font-awesome-icon :icon="['fa', submenuAdministrativo ? 'minus' : 'plus']" class="submenu-icon" />
            </a>
            <ul v-if="submenuAdministrativo" class="submenu">
              <li v-if="$store.getters.user.access.indexOf(24) > -1">
                <router-link to="/admin/user-list">Usuários</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(25) > -1">
                <router-link to="/admin/timelogs">Tempo de Logs</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(26) > -1">
                <router-link to="/admin/logaccess">Log de Acesso</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(27) > -1">
                <router-link to="/admin/configs">Configurações</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(28) > -1">
                <router-link to="/admin/reports">Relatórios</router-link>
              </li>
              <li v-if="$store.getters.user.access.indexOf(28) > -1">
                <router-link to="/admin/report-export-logs">Logs de Relatórios</router-link>
              </li>
            </ul>
          </li>
          <li v-if="$store.getters.user.access.indexOf(40) > -1">
            <router-link to="/admin/telemetry">
              <font-awesome-icon :icon="['fa', 'broadcast-tower']" style="margin-right: auto" />
              <span>Telemetria</span>
            </router-link>
          </li>

          <li>
            <a @click="toggleSubmenu('trocar-empresa')" class="submenu-trigger">
              <font-awesome-icon :icon="['fa', 'building']" />
              <span>Trocar Empresa</span>
              <font-awesome-icon :icon="['fa', submenuTrocarEmpresa ? 'minus' : 'plus']" class="submenu-icon" />
            </a>
            <ul v-if="submenuTrocarEmpresa" class="submenu">
              <li v-for="(userCompany, index) in $store.getters.userCompanies" :key="index">
                <a @click="trocarEmpresa(userCompany)">{{ userCompany.customer.name }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="changingCompany">
      <div class="content-body" style="min-height: 780px">

        <div class="container-fluid">
          <div class="card-body text-center">
            <h1>Trocando de empresa...</h1>
            <span class="fa fa-spinner fa-spin fa-5x"></span>
          </div>
        </div>
      </div>
    </div>
    <template v-else>

      <div class="content-body" style="min-height: 780px" v-if="$store.getters.loaded && !changingCompany">
        <router-view :key="currentCompany"></router-view>
      </div>
      <div v-else>
        <div class="card-body text-center">
          <span class="fa fa-spinner fa-spin fa-5x" style="color: #000;background-color: #fff;"></span>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
// import Breadcrumb from './Breadcrumb.vue'
import HeaderBar from "./Header.vue";
import env from "../../env.js";

export default {
  data() {
    return {
      notIsScreem: true,
      loading: true,
      showAlert: false,
      isMobileMenuOpen: false,
      menuFinanceiroOpened: false,
      menuCotacaoOpened: false,
      menuDocumentsOpened: false,
      menuPedidosOpened: false,
      menuAdministrativoOpened: false,
      menuDeliveryOpened: false,
      footerName: "Grupo BAUMINAS",
      dotEnv: {
        isAmbientaly: false,
      },
      submenuFinanceiro: false,
      submenuPedidos: false,
      submenuDocumentos: false,
      submenuAdministrativo: false,
      submenuTrocarEmpresa: false,
      changingCompany: false,
    };
  },
  computed: {
    currentCompany() {
      return this.$store.state.user.customer_id;
    },
  },
  methods: {
    handleChangingCompany(value) {
      console.log('Changing company status:', value);
      this.changingCompany = value;
      if (!value) {
        // Força uma atualização do componente
        this.$nextTick(() => {
          this.changingCompany = false;
        });
      }
    },
    checkScreenWidth() {
      var element = document.getElementById("mainAPPDiv");
    },
    activateSpinner() {
      this.loading = true
    },
    handleAlertOk() {
      this.showAlert = false;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    logout: function () {
      this.$swal
        .fire({
          title: "Tem certeza que deseja sair?",
          text: "Esta operação não poderá ser desfeita.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$router.push("/login");
            this.$store.dispatch("logout");
          }
        });
    },
    openMenu() {
      this.menuCotacaoOpened = false;
      this.menuDocumentsOpened = false;
      this.menuPedidosOpened = false;
      this.menuAdministrativoOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuFinanceiroOpened =
        this.menuFinanceiroOpened == true ? false : true;
      if (this.menuFinanceiroOpened) {
        $("#menuFinanceiro").addClass("mm-show");
      } else {
        $("#menuFinanceiro").removeClass("mm-show");
      }
    },
    openMenuCotacao() {
      this.menuFinanceiroOpened = false;
      this.menuDocumentsOpened = false;
      this.menuPedidosOpened = false;
      this.menuAdministrativoOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuCotacaoOpened = this.menuCotacaoOpened == true ? false : true;
      if (this.menuCotacaoOpened) {
        $("#menuCotacoes").addClass("mm-show");
      } else {
        $("#menuCotacoes").removeClass("mm-show");
      }
    },
    openMenuDelivery() {
      this.menuFinanceiroOpened = false;
      this.menuCotacaoOpened = false;
      this.menuDocumentsOpened = false;
      this.menuPedidosOpened = false;
      this.menuAdministrativoOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuDeliveryOpened = this.menuDeliveryOpened == true ? false : true;
      if (this.menuDeliveryOpened) {
        $("#menuDelivery").addClass("mm-show");
      } else {
        $("#menuDelivery").removeClass("mm-show");
      }
    },
    openMenuOrder() {
      this.menuFinanceiroOpened = false;
      this.menuCotacaoOpened = false;
      this.menuDocumentsOpened = false;
      this.menuAdministrativoOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuPedidosOpened = this.menuPedidosOpened == true ? false : true;
      if (this.menuPedidosOpened) {
        $("#menuPedidos").addClass("mm-show");
      } else {
        $("#menuPedidos").removeClass("mm-show");
      }
    },
    openMenuDocuments() {
      this.menuFinanceiroOpened = false;
      this.menuCotacaoOpened = false;
      this.menuPedidosOpened = false;
      this.menuAdministrativoOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuDocumentsOpened =
        this.menuDocumentsOpened == true ? false : true;
      if (this.menuDocumentsOpened) {
        $("#menuDocuments").addClass("mm-show");
      } else {
        $("#menuDocuments").removeClass("mm-show");
      }
    },
    openMenuAdministrativo() {
      this.menuFinanceiroOpened = false;
      this.menuCotacaoOpened = false;
      this.menuDocumentsOpened = false;
      this.menuPedidosOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuAdministrativoOpened =
        this.menuAdministrativoOpened == true ? false : true;
      if (this.menuAdministrativoOpened) {
        $("#menuAdministrativo").addClass("mm-show");
      } else {
        $("#menuAdministrativo").removeClass("mm-show");
      }
    },
    toggleSubmenu(menu) {
      switch (menu) {
        case 'financeiro':
          this.submenuFinanceiro = !this.submenuFinanceiro;
          break;
        case 'pedidos':
          this.submenuPedidos = !this.submenuPedidos;
          break;
        case 'documentos':
          this.submenuDocumentos = !this.submenuDocumentos;
          break;
        case 'administrativo':
          this.submenuAdministrativo = !this.submenuAdministrativo;
          break;
        case 'trocar-empresa':
          this.submenuTrocarEmpresa = !this.submenuTrocarEmpresa;
          break;
      }
    },
  },
  created() {
    this.footerName = env.footerName;
    this.dotEnv.isAmbientaly = env.isAmbientaly;
  },
  mounted() {
    this.checkScreenWidth();
    // Opcional: Adicionar um listener para mudanças de tamanho da janela
    window.addEventListener("resize", this.checkScreenWidth);
    this.loading = false
  },
  beforeUnmount() {
    // Remover listener ao desmontar o componente
    window.removeEventListener("resize", this.checkScreenWidth);
  },
  components: {
    HeaderBar,
  },
  watch: {
    // Observa mudanças no currentCompany
    currentCompany: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          setTimeout(() => {
            this.changingCompany = false;
          }, 1000);
        }
      }
    }
  }
};
</script>

<style>
body {
  height: 100vh;
  margin: 0;
  padding: 0;

  background-image: unset;
  /* Caminho da sua imagem */
  background-size: unset;
  /* Cobre todo o fundo */
  background-position: unset;
  /* Centraliza a imagem */
  background-repeat: unset;
  /* Evita repetição da imagem */
  display: block;
  justify-content: center;
  align-items: center;
}

[data-sidebar-style="full"] .metismenu>li.active-menu.mm-active {
  width: 100% !important;
}

.deznav-scroll {
  overflow-y: scroll;
  /* Adiciona uma barra de rolagem somente quando necessário */
  scrollbar-width: none;
  /* Define a largura da barra de rolagem como fina (não é suportado no Safari) */
  scrollbar-color: #888888 #f0f0f0;
  /* Define as cores da barra de rolagem (não é suportado no Safari) */
}

.deznav-scroll::-webkit-scrollbar {
  width: 1px;
  /* Largura da barra de rolagem */
}

.mm-active:hover {
  cursor: pointer;
}
</style>
<style scoped>
.menu-icon {
  font-family: Roboto, sans-serif;
  min-width: 25px !important;
  max-width: 25px !important;
  min-height: 25px !important;
  max-height: 25px !important;
}

.menu-sub-icon {
  min-width: 15px !important;
  max-width: 15px !important;
  min-height: 15px !important;
  max-height: 15px !important;
  font-weight: 100;
}

.card {
  position: absolute;
  margin: 50% 300%;
  padding: 20px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-align: center;
}

.custom-alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.custom-alert-content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.custom-alert-content h2 {
  margin-top: 0;
}

.custom-alert-content button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.custom-alert-content button:hover {
  background-color: #0056b3;
}

.menu-item-novo {
  position: relative;
}

.menu-item-novo::after {
  content: "Novo";
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
  background-color: red;
  color: white;
  padding: 2px 6px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: bold;
  animation: blink 1s infinite;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

/* Estilos para o menu mobile */
.mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 280px;
  height: 100vh;
  background: #fff;
  z-index: 9999;
  transition: right 0.3s ease;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.mobile-menu.active {
  right: 0;
}

.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #eee;
  background: #fff;
}

.mobile-logo img {
  height: 40px;
}

.close-menu {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
}

.mobile-menu-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
}

.mobile-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu-list li {
  margin: 0;
}

.mobile-menu-list li a {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  transition: background-color 0.3s;
  position: relative;
}

.mobile-menu-list li a svg:first-child {
  width: 20px;
  margin-right: 10px;
  color: #666;
}

.mobile-menu-list li a span {
  flex: 1;
  margin-left: 10px;
}

.mobile-menu-list li a:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.mobile-menu-list li.active a {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--primary);
}

.mobile-menu-list li svg {
  width: 20px;
  margin-right: 10px;
  color: #666;
}

/* Esconder menu desktop em telas pequenas */
@media only screen and (max-width: 1024px) {
  .desktop-menu {
    display: none;
  }

  .content-body {
    margin-left: 0px !important;
  }
}

/* Ajustes no header para mobile */
@media only screen and (max-width: 1024px) {

  .content-body {
    margin-left: 0px;
  }

  .container-fluid {
    margin-left: 0px;
  }

  .nav-header {
    width: 100%;
    padding: 0 15px;
  }

  .brand-logo {
    padding: 0;
  }

  .logo-full {
    display: none;
  }

  .logo-mini {
    display: block;
  }

  .nav-control {
    right: 15px;
  }
}

/* Overlay para o menu mobile */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.mobile-menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* Estilos para submenus no mobile */
.submenu-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}

.submenu-trigger .submenu-icon {
  margin-left: auto;
  margin-right: 0;
  transition: transform 0.3s ease;
}

.submenu {
  padding-left: 20px;
  background-color: rgba(0, 0, 0, 0.02);
  margin-left: 20px;
}

.submenu li a {
  padding: 10px 20px;
  font-size: 0.9em;
  display: flex;
  align-items: center;
}

.submenu li a svg {
  margin-right: 10px;
  width: 16px;
  color: #666;
}

.submenu li a span {
  margin-left: 10px;
}

.hamburger {
  position: absolute;
  right: 10px;
  float: right;
  top: 15px;
  left: unset;
}

@media (min-width: 1024px) {
  .hidden-md-and-up {
    display: none !important;
  }
}

.user-company-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-left: 10px;
  display: block;
  position: absolute;
  right: 25%;
  top: 35px;
}

@media (max-width: 480px) {

  .user-company-name {
    top: 75px;
    font-size: 12px;
    text-align: center;
    left: 0;
    right: 0;
    margin-bottom: 10px;
    display: block;
  }

  .content-body {
    margin-top: 20px;
  }
}
</style>
